import { H2 } from '@blueprintjs/core'
import * as React from 'react'

export const Form = ({ input }) => {
  const { props } = input
  return (
    <div>
      <H2>{props.label}</H2>
    </div>
  )
}

export const Configuration = () => {
  return <div />
}
